export class DiagnosticDashboardHeaderConstants {
}
DiagnosticDashboardHeaderConstants.DIAGNOSTICS_DASHBOARD_HEADER_LABEL = 'Diagnostic Scans';
DiagnosticDashboardHeaderConstants.ZERO = 0;
DiagnosticDashboardHeaderConstants.ONE = 1;
DiagnosticDashboardHeaderConstants.ALL = 'All';
DiagnosticDashboardHeaderConstants.NONE = 'None';
DiagnosticDashboardHeaderConstants.TOOLS = 'Tools';
DiagnosticDashboardHeaderConstants.APPLY = 'Apply';
DiagnosticDashboardHeaderConstants.CANCEL = 'Cancel';
DiagnosticDashboardHeaderConstants.DASHBOARD_TITLE_ID = 'dashboardTitle';
DiagnosticDashboardHeaderConstants.TOOL = 'Tool';
DiagnosticDashboardHeaderConstants.APPLY_FOOTER_BUTTON_ID = 'applyFooterButton';
DiagnosticDashboardHeaderConstants.CANCEL_FOOTER_BUTTON_ID = 'cancelFooterButton';
DiagnosticDashboardHeaderConstants.DASHBOARD_HEADER_TOOL_LABEL_ID = 'dashboardHeader_toolLabel';
DiagnosticDashboardHeaderConstants.TOOL_PLACEHOLDER_ID = 'tool_placeholder';
DiagnosticDashboardHeaderConstants.TIMEFRAME_PLACEHOLDER_ID = 'timeframe_placeholder';
DiagnosticDashboardHeaderConstants.CHECK_BOX_DROPDOWN_ID = 'checkboxDropdown';
DiagnosticDashboardHeaderConstants.TOGGLE_BUTTON_ICON_ID = 'dashboardHeaderToggleButtonIcon';
DiagnosticDashboardHeaderConstants.TOGGLE_BUTTON_TEXT_ID = 'dashboardHeaderToggleButtonText';
DiagnosticDashboardHeaderConstants.REFERRER = 'referrer';
DiagnosticDashboardHeaderConstants.TITLE = 'title';
//# sourceMappingURL=DiagnosticsDashboardHeaderConstants.js.map